import React from 'react';
import { useRouteMatch, Link, useLocation } from 'react-router-dom';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

// eslint-disable-next-line import/no-cycle
import routes from '../../routes/routes';

import Text from '../../components/Text';
// eslint-disable-next-line import/no-cycle
import Menu from '../../components/Menu';

import * as Styled from './styles';
import './styles.css';

export default function ApplicationLayout({
  menuOnly,
  RightComponent,
  children,
  isOld = false,
  title,
}) {
  const location = useLocation();
  const match = useRouteMatch(location.pathname);

  const breadcrumbs = routes
    .filter(({ path }) => match.path.includes(path))
    .map(({ path, ...rest }) => ({
      path: Object.keys(match.params).length
        ? Object.keys(match.params).reduce(
            (acc, param) => acc.replace(`:${param}`, match.params[param]),
            path
          )
        : path,
      ...rest,
    }))
    .sort((a, b) => a.path.length - b.path.length);

  const { length, [length - 1]: last, 1: second } = breadcrumbs;

  return (
    <>
      <Menu path={second} />
      <Styled.Header isOld={isOld} className="header-main">
        {!menuOnly && (
          <Container id="header-container">
            <Row>
              <Col lg={6} md={6} xs={4} className="py-3 left-component">
                <Text type="subtitle" color="white" className="text-title">
                  {title || last.title}
                </Text>
                <Styled.Breadcrumb listProps={{ className: 'p-0' }}>
                  {breadcrumbs.map(bread => (
                    <Styled.BreadcrumbItem
                      key={bread.path}
                      linkAs={Link}
                      linkProps={{ to: bread.path }}
                    >
                      <Text type="label" color="white">
                        {bread.title}
                      </Text>
                    </Styled.BreadcrumbItem>
                  ))}
                </Styled.Breadcrumb>
              </Col>
              <Col lg={6} md={6} xs={8} className="py-3 right-component">
                {RightComponent}
              </Col>
            </Row>
          </Container>
        )}
      </Styled.Header>
      <Styled.Main isOld={isOld}>{children}</Styled.Main>
    </>
  );
}
